import { history } from '../routing/index.web';

export const openUrl = (url: string, destination: '_blank' |'_self' = '_blank') => {
  destination === '_blank' ? window.open(url, destination) : history.push(url);
};



// WEBPACK FOOTER //
// ./src/modules/links/index.web.ts